/**
 * CurrentlyReadingSection — "N readers are currently reading this" social
 * proof, same copy pattern as bookshelf's BookCard "friends reading" line,
 * with a small stacked-avatar-initials row (same visual language as the
 * reader-count strip in site/Hero.jsx).
 */

import React from 'react';

const TONE_BG = {
  coral: 'bg-coral',
  sage: 'bg-sage',
  yellow: 'bg-yellow',
  blue: 'bg-blue',
};

export default function CurrentlyReadingSection({ currentlyReading }) {
  if (!currentlyReading || currentlyReading.count === 0) return null;
  const { count, sample } = currentlyReading;

  return (
    <section className="u-container mt-10 md:mt-14" data-testid="book-details-currently-reading">
      <div className="flex items-center gap-3">
        <div className="flex -space-x-2">
          {sample.map((reader) => (
            <span
              key={reader.handle}
              className={`grid h-8 w-8 place-items-center rounded-full border-2 border-cream text-xs font-semibold text-ink/80 ${TONE_BG[reader.tone] ?? TONE_BG.coral}`}
              title={reader.name}
            >
              {reader.name[0]}
            </span>
          ))}
        </div>
        <p className="text-sm text-subtle">
          <span className="font-semibold text-ink">{count}</span> reader{count > 1 ? 's are' : ' is'} currently reading this
        </p>
      </div>
    </section>
  );
}
